<template>
  <div v-if="posts && posts.length" class="w-full lg:h-120 bg-truegray-700">
    <div class="w-full bg-white text-truegray-500 lg:ml-0 lg:hidden py-16 px-8">
      <div class="border-l-8 border-truegray-500 px-8">
        <h2>Related posts</h2>
      </div>
    </div>

    <div class="h-auto lg:h-full w-full relative">
      <div
        class="flex flex-col h-auto lg:h-full w-fulltext-whiteoverflow-x-hidden"
      >
        <div
          class="post-content-wrapper pr-8 lg:pr-0 flex flex-wrap lg:flex-nowrap h-full relative"
        >
          <!-- COLUMN 1 -->

          <div
            class="w-full lg:w-6/12 text-white ml-12 mt-12 border-t border-white pt-4 pr-16"
            :class="[
              postChanging
                ? 'opacity-0'
                : 'opacity-100 transition-all duration-300 ease-in-out',
            ]"
          >
            <h5>
              {{ posts[activePost].created_at_ui }}
            </h5>

            <h2 class="mb-0 clamp-title">{{ posts[activePost].title }}</h2>

            <PostTags
              v-if="
                posts[activePost].year_tag && posts[activePost].year_tag.length
              "
              :tags="posts[activePost].year_tag"
              :list-class="['mt-4']"
              :text-white="true"
            />

            <PostTags
              v-if="
                posts[activePost].general_tags &&
                posts[activePost].general_tags.length
              "
              :tags="posts[activePost].general_tags"
              :list-class="
                posts[activePost].year_tag && posts[activePost].year_tag.length
                  ? ['mt-0']
                  : []
              "
              :text-white="true"
            />

            <!-- EVENT -->
            <h5
              v-if="posts[activePost].category === 3"
              class="flex items-center mt-8"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>{{ posts[activePost].event_start_at_ui }}</span>
              <span
                v-if="
                  posts[activePost].event_end_at_ui &&
                  posts[activePost].event_start_at_ui !=
                    posts[activePost].event_end_at_ui
                "
              >
                - {{ posts[activePost].event_end_at_ui }}</span
              >
            </h5>

            <h5
              v-if="posts[activePost].category === 3"
              class="flex items-center mb-8"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                  clip-rule="evenodd"
                /></svg
              >{{ posts[activePost].event_venue_title }}
            </h5>

            <!-- JOB -->
            <h5
              v-if="posts[activePost].category === 2"
              class="flex items-center mt-8"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clip-rule="evenodd"
                />
              </svg>
              {{ jobTypes[posts[activePost].job_type].text }}
            </h5>
            <h5
              v-if="posts[activePost].category === 2"
              class="flex items-center mb-8"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                  clip-rule="evenodd"
                />
              </svg>
              {{ posts[activePost].job_employer }}
            </h5>

            <button
              :id="posts[activePost].id"
              class="btn btn-trans-white mt-4"
              @click="viewPost(posts[activePost].id)"
            >
              Read more
            </button>
          </div>

          <!-- COLUMN 2 -->
          <div
            class="w-full lg:w-6/12 bg-transparent lg:bg-white pr-16 pt-16 relative"
          >
            <div
              class="w-full lg:w-1/2 border-l-8 border-truegray-500 pl-8 text-truegray-500 lg:ml-auto lg:block hidden"
            >
              <h2>Related posts</h2>
              <p>Browse similar posts</p>
            </div>

            <!-- Featured posts Show reel -->
            <div
              class="post-image-node-container h-80 lg:absolute lg:-left-16 lg:bottom-0 z-40 overflow-x-hidden overflow-y-visible pb-8 lg:p-0"
            >
              <div
                class="post-image-node-wrapper flex justify-center items-end relative transition-all duration-500 ease-in-out"
                :style="{ right: menuPosition }"
              >
                <div
                  v-for="(post, i) in posts"
                  :key="i"
                  :ref="'relatedPosts-' + i"
                  :class="[
                    activePost === i ? activeClass : '',
                    i < activePost ? '' : '',
                    i > activePost ? '' : '',
                    postClass,
                  ]"
                  :style="{
                    backgroundImage: 'url(' + post.image_featured + ')',
                  }"
                  class="bg-cover bg-truegray-100 flex items-center justify-center"
                  @click="goToPost(i)"
                >
                  <div
                    v-if="!post.image_featured"
                    class="rounded-4xl w-full h-full"
                  >
                    <div
                      :style="[
                        post.category === 1
                          ? { backgroundImage: 'url(/img/default-news.jpg)' }
                          : {},
                        post.category === 2
                          ? { backgroundImage: 'url(/img/default-job.png)' }
                          : {},
                        post.category === 3
                          ? { backgroundImage: 'url(/img/default-event.png)' }
                          : {},
                      ]"
                      class="w-full h-full bg-cover bg-center bg-no-repeat rounded-4xl"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Arrows -->
    <div class="flex">
      <div class="w-1/2 hidden lg:block"></div>

      <div
        class="w-full lg:w-1/2 flex justify-between items-center relative z-50"
      >
        <div class="flex justify-between lg:absolute lg:bottom-0 w-full pl-6">
          <div
            class="pb-4 pl-8 hover:text-primary lg:text-black text-white"
            :class="[
              activePost > 0 ? '' : 'opacity-0',
              'transition-all duration-300 ease-in-out',
            ]"
            @click="scrollLeft()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 featured-post-arrow cursor-pointer"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16l-4-4m0 0l4-4m-4 4h18"
              />
            </svg>
          </div>
          <div
            class="pb-4 pr-8 hover:text-primary lg:text-black text-white"
            :class="[
              activePost >= posts.length - 1 ? 'opacity-0' : '',
              'transition-all duration-300 ease-in-out',
            ]"
            @click="scrollRight()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 featured-post-arrow cursor-pointer"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- /Arrows -->
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../../js/plugins/event-bus.js'
import PostTags from '../../../../shared/components/PostTags.vue'
import { mapGetters } from 'vuex'
import { JOB_TYPES } from '../../../../js/util/constants.js'

export default {
  components: { PostTags },

  data() {
    return {
      activePost: 0,
      postClass:
        'h-48 w-48 border-white mx-4 border-8 bg-center cursor-pointer rounded-4xl transition-all duration-500 ease-in-out filter hover:shadow-xl',
      activeClass: 'h-64 w-64',
      sliderWidth: '',
      menuPosition: '0rem',
      postChanging: false,
      posts: [],
      jobTypes: JOB_TYPES,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      currentPost: 'shared/getCurrentPost',
    }),
  },

  watch: {
    currentPost: {
      handler: function (post) {
        if (post.related) {
          this.$set(this, 'posts', post.related)
        }
      },

      deep: true,
    },

    posts: {
      handler: function () {
        this.setTags()
      },

      deep: true,
    },
  },

  mounted() {
    this.checkWidth()
    if (this.currentPost) {
      // this.$nextTick(() => { /** ... */ } )
      if (this.currentPost.related_posts) {
        this.$set(this, 'posts', this.currentPost.related)
      }
    }
  },

  methods: {
    goToPost(i) {
      this.$set(this, 'postChanging', true)
      this.$set(this, 'activePost', i)
      this.changeMenuPosition()
      setTimeout(() => {
        this.$set(this, 'postChanging', false)
      }, 400)
    },

    viewPost(id) {
      this.$router.push({ path: `/post/${id}` })
      EventBus.$emit('NonManagerRouteClicked')
    },

    checkWidth() {
      //post count +1 for see all * post width + featured consideration + margin consideration
      let calcWidth = (this.posts.length + 1) * 12 + 6 + 2
      this.$set(this, 'sliderWidth', calcWidth + 'rem')
    },

    changeMenuPosition() {
      let right = this.activePost * 13.66
      this.$set(this, 'menuPosition', right + 'rem')
    },

    scrollLeft() {
      if (this.activePost > 0) {
        this.$set(this, 'postChanging', true)
        this.$set(this, 'activePost', this.activePost - 1)
        this.changeMenuPosition()
        setTimeout(() => {
          this.$set(this, 'postChanging', false)
        }, 400)
      }
    },

    scrollRight() {
      if (this.activePost < this.posts.length - 1) {
        this.$set(this, 'postChanging', true)
        this.$set(this, 'activePost', this.activePost + 1)
        this.changeMenuPosition()
        setTimeout(() => {
          this.$set(this, 'postChanging', false)
        }, 400)
      }
    },

    setTags() {
      if (this.posts.length > 0) {
        this.posts.forEach((post) => {
          //general tags
          let general_arr = []
          this.settings.tags.forEach((i) => {
            if (post.tag_titles.includes(i.text)) {
              general_arr.push(i.text)
            }
          })
          post.general_tags = general_arr

          // Year tags
          let year_arr = []
          this.settings.tag_years.forEach((i) => {
            if (post.tag_titles.includes(i.text)) {
              year_arr.push(i.text)
            }
          })
          post.year_tag = year_arr

          // Region tags
          let region_arr = []
          this.settings.tag_regions.forEach((i) => {
            if (post.tag_titles.includes(i.text)) {
              region_arr.push(i.text)
            }
          })
          post.region_tag = region_arr
        })
      } // end if
    },
  },
}
</script>

<style scoped>
.post-image-node-container {
  width: calc(100% + 4rem);
}

.post-image-node-wrapper {
  width: fit-content;
}

.clamp-title {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (max-width: 1024px) {
  .post-image-node-container {
    height: 20rem;
  }
}
</style>
